import React, { memo } from "react";
import { Table, Space } from "@mantine/core";
import classes from "./Lcatable.module.css";

const LcaTable = ({data}:any) => {

    // Define stage names and corresponding data keys
    const tableData = [
        { stage: "Embodied Materials", value: data?.materialOfComponent},
        { stage: "Upstream Transport", value: data?.transportOfComponent},
        { stage: "Production", value: data?.processFactoryCo2 },
        { stage: "Total Embodied", value: data?.componentCo2},
        { stage: "Transport", value: data?.journeyTransportCo2 ?? "0.000" },
        { stage: "Packaging", value: data?.totalPackagingCo2 ?? "0.000" },
        { stage: "Disposal", value: data?.totalDisposalCo2 ?? "0.000" },
        { stage: "Total", value: data?.totalCo2 ?? "0.000" }
    ];

    return (
        <div className={classes.main} style={{marginTop:'15px'}}>
            <Space h="md" />
            {/* Table */}
            <Table withRowBorders={false} horizontalSpacing="xs" verticalSpacing="xs">
                <Table.Thead>
                    <Table.Tr>
                        <Table.Th style={{ fontWeight: "bold", color: "#777" , backgroundColor:'#4040401A'}}>Stage</Table.Th>
                        <Table.Th style={{ fontWeight: "bold", color: "#777" , backgroundColor:'#4040401A'}}>kgCO2e*</Table.Th>
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {tableData.map((row, index) => (
                        <Table.Tr key={index}>
                            <Table.Td style={{ fontWeight: "bold" }}>{row.stage}</Table.Td>
                            <Table.Td>{parseFloat(row.value).toFixed(5)}</Table.Td>
                        </Table.Tr>
                    ))}
                </Table.Tbody>
            </Table>
            {/* {getlistError && <p style={{ color: "red" }}>Error: {getlistError.message}</p>} */}
             <Space h="xl" />
             <Space h="md" />
        </div>
    );
};

export default memo(LcaTable);
